import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import { Grid, TextField, Snackbar } from "@material-ui/core";

import { withRouter } from "react-router-dom";

import { getUserInfo, getTrackerList } from "../../actions/subscribe";
import { searchFileList } from "../../actions/index"
import store from "../../store";

import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { Table, DatePicker, Button, Input, Select } from 'antd';

const { Option } = Select;
import axios from 'axios'

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "110px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {
      marginTop: "12px",
    },
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "2px !important",
    },    
    grayBtn: {
      width: "97px",
      height: "40px",
      marginLeft: "18px !important",
      background: "#fff !important",
      borderRadius: "2px !important",
      border: '1px solid #d9d9d9 !important',
      color: '#0F25D1 !important',
      boxShadow: 'none !important'
    },
    container: {
    },
    list: {
      width: "1px",
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      position: "sticky",
      top: "80px",
      minHeight: "400px",
      maxHeight: "calc(100vh - 140px)",
      padding: "20px 26px 20px 16px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0px 1px 10px 1px rgba(0, 0, 0, 0.05)",
      overflow: "auto",
    },
    labelTitle: {
      display: "flex",
      justifyContent: "space-between",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    switch: {
      width: "68px !important",
      height: "22px !important",
      padding: "0 12px !important",
      "& .MuiSwitch-track": {
        width: "44px",
        height: "22px",
        borderRadius: "11px",
      },
      "& .MuiSwitch-switchBase": {
        padding: "0",
        "&:hover": {
          background: "none",
        },
        "&.Mui-checked+.MuiSwitch-track": {
          backgroundColor: "#3DBD7D",
        },
        "& .MuiTouchRipple-root": {
          background: "#fff",
          transform: "translate(14px, 1px)",
        },
        "& .MuiSwitch-thumb": {
          background: "#fff",
          transform: "translate(14px, 1px)",
        },
      },
    },
    switchLabel: {
      "& .MuiFormControlLabel-label": {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#5F6876",
      },
    },
    subTitle: {
      margin: "20px 0 16px",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#3276C3",
        borderColor: "#3276C3",
      },
    },
    select: {
      width: '100%'
    },
    linkText: {
      color: '#333',
      '&:hover': {
        color: '#333',
        textDecoration: 'underline'
      }
    }
  };
};

class Tracker extends Component {
  state = {
    keyword: "",
    error: "",
    is_all: 0,
    tabIndex: 0,
    count: 0,
    userId: "", //用户id
    username: "", //用户名
    modalTitle: "",
    openMessage: "",
    fileTotal: 0,
    errorMessage: "",
    push: true,
    openModal: false,
    isFirst: true,
    fileList: [],
    updateTime: '',
    searchHistoryList: [],
    tabList: [
      {
        title: '公众号文章',
      },
      {
        title: '官方新闻',
      },
    ],
    form: {
      type: "",
      keyword: "",
    },
    defaultForm: { // 默认值
      type: "",
      keyword: "",
    },
    labelObj: { // 筛选项key - label对应关系
      type: '搜索类型',
      keyword: '关键词',
    },
    labelListObj: { 
      type: 'searchTypeList'
    },
    selectKeys: ['type'],
    searchTypeList: [
      {
        ID: '',
        Name: '精确搜索'
      },
      {
        ID: 'all',
        Name: '全文搜索'
      },
      {
        ID: 'ai',
        Name: '智能检索'
      },
    ],
    loading: false,
    data: [],
    scrollObj: {
      x: 1560,
      y: 600
    },
    columns: [
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 120,
        align: 'center',
        render: (text, row) => {
          let data = row.base_file ? row.base_file : row
          return (
            <>
              <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadFile(data.dfs_url, data.file_name)}>下载</Button>
            </>
          )
        }
      },
      {
        title: '文件名称',
        dataIndex: 'TotalSerialNumber',
        key: 'TotalSerialNumber',
        width: 360,
        render: (text, row) => {
          let data = row.base_file ? row.base_file : row
          return <a onClick={() => this.previewFile(row.dfs_url)} className={this.props.classes.linkText} >{data.file_name}</a>          
        }
      },
      {
        title: '发布机构',
        dataIndex: 'medical_file_publish_orgnization',
        key: 'medical_file_publish_orgnization',
        width: 160,
        render: (text, row) => {
          let data = row.medical_file_publish_orgnization || row.medical_file_admin_location
          return data
        }
      },
      {
        title: '发布时间',
        dataIndex: 'medical_file_publish_date',
        key: 'medical_file_publish_date',
        width: 160,
        render: (text, row) => {
          let data = row.medical_file_publish_date || ''
          return data.substring(0, 10)
        }
      },
      {
        title: '来源出处',
        dataIndex: 'dfs_url',
        key: 'dfs_url',
        width: 360,
        render: (text, row) => {
          let data = row.base_file ? row.base_file : row
          return <a target="_blank" href={data.medical_file_origin || data.medical_file_website_link}>{data.medical_file_origin || data.medical_file_website_link}</a>
        }
      },
    ],
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      current: 1,
      pageSize: 10,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条'
      },
    },
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1560,
        y: height - lineHeight - 260
      }
    })
  }

  componentDidMount() {
    this.getTableHeight()
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let keyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          keyword,
          type: 'ai'
        }
      }, () => {this.searchForm()})
    } else {
      this.loadMore();
    }

  }

  downloadFile = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };
  

  resetForm = () => {
    this.setState({
      form: {
        type: "",
        keyword: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.loadMore())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.loadMore())
  }

  searchForm = () => {
    let paginationObj = {
      ...this.state.paginationObj,
      current: 1
    }
    this.setState({
      paginationObj: paginationObj
    }, () => this.loadMore())
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }


  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  
  previewFile = (url) => {
    localStorage.setItem('previewUrl', url);
    const w = window.open("ablut:blank");
    w.location.href = "/preview";
  };


  loadMore = (isInit) => {
    let searchType = ""
    if (this.state.form.type == "all") {
      searchType = "全文检索"
    } else if (this.state.form.type == 'ai') {
      searchType = '智能检索'
    }
    const param = {
      keyword: this.state.form.keyword,
      search_type: searchType,
      file_category_type: this.state.tabIndex === 0 ? '新闻资讯' : '官方新闻',
      page: this.state.paginationObj.current,
      pageSize: this.state.paginationObj.pageSize
    };
    searchFileList({
      ...param,
    }).then(res => {
      if (res && res.result) {
        let data = res.result
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.count
        this.setState({
          data: data,
          paginationObj: newPaginationObj,
          loading: false
        });
      } else {
        this.setState({
          loading: false
        })
      }
    })
  };



  showResult = () => {
    if (this.state.keyword == "") {
      if (this.state.count == 0) {
        return "没有找到您想要的内容，请联系管理员添加";
      } else return "没有了";
    } else {
      if (this.state.count == 0) {
        return "没有找到您想要的内容，请更换关键词";
      } else return "没有了";
    }
  };

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  changeTab = (data, i) => {
    this.setState(
      {
        tabIndex: i,
      },
      () => {
        this.loadMore();
      }
    );
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
        paginationObj: pagination
      },
      () => {
        this.loadMore();
      }
    );
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">搜索类型</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.type}
                onChange={(e) => this.onChangeForm(e, 'type')} 
              >
                {
                  this.state.searchTypeList.map((v, i) => {
                    return (
                      <Option value={v.ID} key={i}>{v.Name}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.keyword}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                placeholder="请输入关键词"/>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">新闻资讯</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <div className="main-top">
              <div>
                {
                  
                  this.state.tabList.map((v, i) => (
                    <span
                      key={i}
                      onClick={() => this.changeTab(v, i)}
                      className={[
                        "main-tab",
                        this.state.tabIndex == i ? "active" : "",
                      ].join(" ")}
                    >
                      {v.title}
                    </span>
                  ))
                }
              </div>
            </div>
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                scroll={this.state.scrollObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Tracker));
